import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreateInventoryCategory } from "../../../hooks/inventory/useCreateInventoryCategory";

const DefaultCategoriesSeederDialog = ({ open = false, setOpen, successCallback }) => {

    const { t } = useTranslation('common');

    const defaultCategories = [
        {name: "Medications", description: "Prescription drugs, specialty medications, antibiotics, etc."},
        {name: "Vaccines", description: "Often categorized separately due to unique storage requirements and tracking needs."},
        {name: "Surgical Supplies", description: "Anesthesia, sutures, surgical instruments, etc."},
        {name: "Consumable Medical Supplies", description: "Syringes, needles, gauze, cotton balls, etc."},
        {name: "Laboratory & Diagnostic Materials", description: "Microscope slides, blood transfusion sets, urine sampling kits, etc."},
        {name: "Pet Food & Nutrition", description: "Standard retail food, specialized prescription diets, etc."},
        {name: "Over-the-Counter Retail Items", description: "Shampoos, flea and tick preventatives, collars, leashes, grooming supplies, etc."},
        {name: "Office Supplies", description: "Printer paper, toner, office stationery, etc."},
        {name: "Capital Equipment", description: "High-value assets like X-ray machines, ultrasounds, etc."}
    ];
    
    const handleClose = (event, reason) => {
        // Prevent closing when clicking the backdrop or pressing Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        setOpen(false);
    };

    const { create } = useCreateInventoryCategory(successCallback);

    const onConfirm = () => {
        createDefaultCategories();
        setOpen(false);
    }

    const createDefaultCategories = async () => {
        await create(defaultCategories);
    };

    return (
        <Dialog open={open} onClose={handleClose} disableRestoreFocus>
                <DialogTitle>
                    Categories Inital Setup...
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        The system has created a default set of Inventory Categories. 
                        <br /><br />
                        Customize this list by going to the Inventory Categories management.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={onConfirm}
                    color="primary"
                    >
                    Got it
                    </Button>
                </DialogActions>
        </Dialog>
  );
};

export default DefaultCategoriesSeederDialog;